import { render, staticRenderFns } from "./userGroupManagement.vue?vue&type=template&id=2f1e320e&scoped=true&"
import script from "./userGroupManagement.vue?vue&type=script&lang=js&"
export * from "./userGroupManagement.vue?vue&type=script&lang=js&"
import style0 from "./userGroupManagement.vue?vue&type=style&index=0&id=2f1e320e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1e320e",
  null
  
)

export default component.exports